import React, { useState } from 'react';

import { KyuLaurelBadgeIcon } from 'app/components/shared/icons';

// Reset a failed image when the campaign's configured URL changes.
function CategoryImage({ src, alt = '' }: { src?: string | null; alt?: string }) {
  const [failed, setFailed] = useState(false);
  return src && !failed ? (
    <img
      src={src}
      alt={alt}
      onError={() => setFailed(true)}
      style={{ width: '100%', height: '100%', objectFit: 'contain' }}
    />
  ) : (
    <KyuLaurelBadgeIcon width={24} height={24} aria-hidden="true" />
  );
}

export default function BestOfCategoryIcon({ src, alt }: { src?: string | null; alt?: string }) {
  return <CategoryImage key={src || 'fallback'} src={src} alt={alt} />;
}
